import { render, staticRenderFns } from "./_MyRessifMappings.vue?vue&type=template&id=5301f7da&"
import script from "./_MyRessifMappings.vue?vue&type=script&lang=ts&"
export * from "./_MyRessifMappings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports